<template>
	<div class="wrapper">
		<header class="main-header">
			<a href="/" class="logo">
				<!-- mini logo for sidebar mini 40x50 pixels -->
				<span class="logo-mini"><img src="/static/img/logo_sm.png" alt="Logo" class="img-responsive center-block"></span>
				<!-- logo for regular state and mobile devices -->
				<div class="container logo-lg">
					<div class="pull-left image"><img src="/static/img/logo_sm.png" alt="Logo" class="img-responsive"></div>
					<div class="pull-left info">United Taxi</div>
				</div>
			</a>

			<!-- Header Navbar -->
			<nav class="navbar navbar-static-top" role="navigation">
				<!-- Sidebar toggle button-->
				<a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
					<span class="sr-only">Toggle navigation</span>
				</a>
				<!-- Navbar Right Menu -->
				<div class="navbar-custom-menu">
					<ul class="nav navbar-nav">
						<!-- Messages-->
						<li class="dropdown messages-menu">
							<a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
								<i class="fa fa-envelope-o"></i>
								<span class="label label-success">{{ state.userInfo.messages | count }}</span>
							</a>
							<ul class="dropdown-menu">
								<li class="header">You have {{ state.userInfo.messages | count }} message(s)</li>
								<li v-if="state.userInfo.messages.length > 0">

									<!-- inner menu: contains the messages -->
									<ul class="menu">
										<li v-for="(item, key, index) in state.userInfo.messages" ><!-- start message -->
                                            <a id="" class="" v-on:click="ClickNoti(index,item.id,item.sender)">
                                            <!--<router-link :to="{ name:'Trip Request',params :{ sender: item.sender }}">-->
												<!-- Message title and timestamp -->
												<h4>
													{{item.title}}
													<small><i class="fa fa-clock-o"></i><span>{{ item.update_time | moment('from', 'now') }}</span></small>

												</h4>
												<!-- The message -->
												<p>{{ item.message }}</p>
											<!--</router-link>-->
                                            </a>
										</li>
										<!-- end message -->
									</ul>
									<!-- /.menu -->
								</li>
								<li class="footer" v-if="state.userInfo.messages.length > 0"><a href="javascript:;">See All Messages</a></li>
							</ul>
						</li>
						<!-- /.messages-menu -->

						<!-- Notifications Menu -->
						<li class="dropdown notifications-menu">
							<a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
								<i class="fa fa-bell-o"></i>
								<span class="label label-warning">{{ state.userInfo.notifications | count }}</span>
							</a>
							<ul class="dropdown-menu">
								<li class="header">You have {{ state.userInfo.notifications | count }} notification(s)</li>
								<li v-if="state.userInfo.notifications.length > 0">
									<!-- Inner Menu: contains the notifications -->
									<ul class="menu">
										<li><!-- start notification -->
											<a href="javascript:;">
												<i class="fa fa-users text-aqua"></i> 5 new members joined today
											</a>
										</li>
										<!-- end notification -->
									</ul>
								</li>
								<li class="footer" v-if="state.userInfo.notifications.length > 0"><a href="javascript:;">View all</a></li>
							</ul>
						</li>

						<!-- Tasks Menu -->
						<li class="dropdown tasks-menu">
							<a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
								<i class="fa fa-flag-o"></i>
								<span class="label label-danger">{{ state.userInfo.tasks | count }} </span>
							</a>
							<ul class="dropdown-menu">
								<li class="header">You have {{ state.userInfo.tasks | count }}  task(s)</li>
								<li v-if="state.userInfo.tasks.length > 0">
									<!-- Inner menu: contains the tasks -->
									<ul class="menu">
										<li><!-- Task item -->
											<a href="javascript:;">
												<!-- Task title and progress text -->
												<h3>
													Design some buttons
													<small class="pull-right">20%</small>
												</h3>
												<!-- The progress bar -->
												<div class="progress xs">
													<!-- Change the css width attribute to simulate progress -->
													<div class="progress-bar progress-bar-aqua" style="width: 20%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
														<span class="sr-only">20% Complete</span>
													</div>
												</div>
											</a>
										</li>
										<!-- end task item -->
									</ul>
								</li>
								<li class="footer" v-if="state.userInfo.tasks.length > 0">
									<a href="javascript:;">View all tasks</a>
								</li>
							</ul>
						</li>

						<!-- User Account Menu -->
						<li class="dropdown user user-menu">
							<a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
								<!-- The user image in the navbar-->
								<img v-bind:src=demo.avatar class="user-image" alt="User Image">
								<!-- hidden-xs hides the username on small devices so only the image appears. -->
								<span class="hidden-xs">{{ demo.displayName }}</span>
							</a>
							<ul class="dropdown-menu">
								<li v-if="demo.displayName != '' ">
									<!-- Inner Menu: User Info -->
									<a v-on:click="logout"  href="javascript:;">
										<h4>
											<i class="fa fa-sign-out text-aqua"></i> Log Out
										</h4>
									</a>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</nav>
		</header>
		<!-- Left side column. contains the logo and sidebar -->
		<aside class="main-sidebar">

			<!-- sidebar: style can be found in sidebar.less -->
			<section class="sidebar">

				<!-- Sidebar user panel (optional) -->
				<div class="user-panel">
					<div class="pull-left image">

					</div>
					<div class="pull-left info">
						<div><p class="white">{{ demo.displayName }}</p></div>
						<a href="javascript:;"><i class="fa fa-circle text-success"></i> Online</a>
					</div>
				</div>

				<!-- Sidebar Menu -->
				<ul class="sidebar-menu">
					<li class="header">TOOLS</li>
					<li id="trip" class="pageLink active" v-on:click="toggleMenu"><router-link :to="{name:'Trip List'}"><i class="fa fa-road"></i><span class="page">Trip List</span></router-link></li>
					<li id="driver" class="pageLink" v-on:click="toggleMenu"><router-link :to="{ name:'Driver List'}"><i class="fa fa-taxi"></i><span class="page">Driver List</span></router-link></li>
					<li id="device" class="pageLink" v-on:click="toggleMenu"><router-link :to="{ name:'Device List'}"><i class="fa fa-mobile"></i><span class="page">Device List</span></router-link></li>
                    <li id="map" class="pageLink" v-on:click="toggleMenu"><a target="_blank" href="/static/admin/index.html" class=""><i class="fa fa-map-marker"></i><span class="page">Map View</span></a></li>
                    <!--<li id="notification" class="pageLink" v-on:click="toggleMenu"><router-link :to="{name:'Notification List'}"><i class="fa fa-bell-o"></i><span class="page">Notification List</span></router-link></li>-->

					<!--<li class="header">ME</li>-->
					<!--<li class="pageLink" v-on:click="toggleMenu"><router-link to="/tasks"><i class="fa fa-tasks"></i><span class="page">Tasks</span></router-link></li>-->
					<!--<li class="pageLink" v-on:click="toggleMenu"><router-link to="/setting"><i class="fa fa-cog"></i><span class="page">Settings</span></router-link></li>-->

					<!--<li class="header">LOGS</li>-->
					<!--<li class="pageLink" v-on:click="toggleMenu"><router-link to="/access"><i class="fa fa-book"></i><span class="page">Access</span></router-link></li>-->
					<!--<li class="pageLink" v-on:click="toggleMenu"><router-link to="/server"><i class="fa fa-hdd-o"></i><span class="page">Server</span></router-link></li>-->
					<!--<li class="pageLink" v-on:click="toggleMenu"><router-link to="/repos"><i class="fa fa-heart"></i><span class="page">Repos</span><small class="label pull-right bg-green">AJAX</small></router-link></li>-->

					<!--<li class="header">PAGES</li>-->
					<!--<li class="pageLink" v-on:click="toggleMenu"><router-link to="/login"><i class="fa fa-circle-o text-yellow"></i> <span class="page">Login</span></router-link></li>-->
					<!--<li class="pageLink" v-on:click="toggleMenu"><router-link to="/404"><i class="fa fa-circle-o text-red"></i> <span class="page">404</span></router-link></li>-->
				</ul>
				<!-- /.sidebar-menu -->
			</section>
			<!-- /.sidebar -->
		</aside>

		<!-- Content Wrapper. Contains page content -->
		<div class="content-wrapper">
			<!-- Content Header (Page header) -->
			<section class="content-header">
				<h1>
					{{ $route.name }}
					<small>{{ $route.description }}</small>
				</h1>
				<ol class="breadcrumb">
					<li><a href="javascript:;"><i class="fa fa-home"></i>Home</a></li>
					<li class="active">{{$route.name }}</li>
				</ol>
			</section>

			<router-view></router-view>
		</div>
		<!-- /.content-wrapper -->

		<!-- Main Footer -->
		<footer class="main-footer">
			<strong>Copyright &copy; {{year}} <a href="javascript:;">United Taxi</a>.</strong> All rights reserved.
		</footer>
	</div>
	<!-- ./wrapper -->
</template>

<script>
import Pusher from 'pusher-js'
require('hideseek')

module.exports = {
  name: 'Dash',
  computed: {
    store: function () {
      return this.$parent.$store
    },
    state: function () {
      return this.store.state
    },
    demo: function () {
      var userinfo = this.store.state.user;
      var picture = userinfo.picture;
      var url = ""
			if (picture && picture.data && !picture.data.is_silhouette) {
        url = picture.data.url;
      }
      return {
        displayName: userinfo.name,
        avatar: url,
        email: userinfo.email,
        randomCard: "aaa"
      }
    },
    year: function () {
      var y = new Date()
      return y.getFullYear()
    }
  },
  methods: {
    changeloading: function () {
      this.store.dispatch('TOGGLE_SEARCHING')
    },
    ClickNoti: function (index,id,sender) {
      const state = this.$store.state
      var store = this.$store
      const self = this
      var url = state.serverURI + 'api/a/update-noti-status'
      this.$http.post(url,{id:id}).then((response) => {
        self.store.state.userInfo.messages.pop(index)
      }, (response) => {
        // error callback
      });
    },
    toggleMenu: function (event) {
      // remove active from li
        window.$('li.pageLink').removeClass('active')
        // Add it to the item that was clicked
        //if(event.toElement.parentElement.type)
        if(event.toElement.parentElement.tagName === 'A'){
            event.toElement.parentElement.parentElement.className = 'pageLink active'
        }
        else{
            event.toElement.parentElement.className = 'pageLink active'
        }
    },
    logout: function () {
        var store = this.$store
        const self = this
        store.dispatch('doSetToken', null )
        store.dispatch('doSetUser', null )

        if (window.localStorage) {
            window.localStorage.removeItem('user')
            window.localStorage.removeItem('token')
        }
        self.$router.push( '/login' )
    }
  },
  mounted: function () {
    // Page is ready. Let's load our functions!
    const self = this
    const routename = self.$route.name
//
    window.$('li.pageLink').removeClass('active')
    if(routename.indexOf("Trip") > -1){
      window.$('li.pageLink#trip')[0].className = 'pageLink active'
    }else if(routename.indexOf("Driver") > -1){
      window.$('li.pageLink#driver')[0].className = 'pageLink active'
    }else if(routename.indexOf("Notification") > -1){
      window.$('li.pageLink#notification')[0].className = 'pageLink active'
    }
  },
  created: function () {
    const state = this.$store.state
    var store = this.$store
    const self = this

    this.pusher = new Pusher('10b1262fcb7456607ed0', {
      cluster: 'ap1',
      encrypted: true
    })
    this.pusherChannel = this.pusher.subscribe('my-channel')
    this.pusherChannel.bind('my-event', (data) => {
      this.store.state.userInfo.messages.push(data)
    })

    var url = state.serverURI + 'api/a/notification?status=0'
    this.$http.get(url).then((response) => {
        var data = response.body;
        self.store.state.userInfo.messages=[];
        data.forEach(function (val ,key) {
          var noti = {
            "message": val.message,
            "title": val.title,
            "sender": val.sender,
            "update_time": val.created,
            "status" : 0,
            "id" : val.id
          };
          self.store.state.userInfo.messages.push(noti)
        })
//      this.$set('someData', response.body);
    }, (response) => {
      // error callback
    });
  }
}
</script>

<style>
.user-panel {
  height: 4em;
}
hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// Home.vue?4cbc2d55